import { createAndDownloadExcel, generateExcelFilename } from './excelExportUtils';
import i18n from '../i18n/i18n';

/**
 * Telemetri geçmiş verilerini Excel formatında indirir.
 * Dosya adı ve sheet adı sabit Türkçe değil; aktif UI diline göre belirlenir.
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {Object} objectData - Object bilgileri
 * @param {Object} enumData - Enum bilgileri
 * @param {string} nodeId - Node ID
 */
export const exportTelemetryHistory = (rows, columns, objectData, enumData, nodeId) => {
  // Enum değerlerini çözümlemek için value transformer
  const valueTransformer = (value, column, row) => {
    // Enum değerlerini çözümle
    if (value !== undefined && value !== null && column.field !== 'date' && column.field !== 'id') {
      const objectItem = objectData.find(
        (objData) => objData.code === parseInt(column.field)
      );

      if (objectItem && objectItem.type === 1) {
        const enumValue = parseInt(value);
        const enumItem = enumData.find(
          (item) => item.enumVal === enumValue
        );
        if (enumItem) {
          return enumItem.name1;
        }
      }
    }
    return value;
  };

  const title = i18n.t('nodeComponents.telemetryHistory.title', {
    defaultValue: 'Telemetry History',
  });

  // Dosya/sheet için sorunlu karakterleri temizle; boşlukları '_' yap.
  const safeTitle = title.replace(/[\\/:*?"<>|[\]]/g, '').trim();
  const prefix = safeTitle.replace(/\s+/g, '_') || 'Telemetry_History';
  // Excel sheet adı en fazla 31 karakter olabilir.
  const sheetName = safeTitle.slice(0, 31) || 'Telemetry History';

  const fileName = generateExcelFilename(prefix, nodeId || 'Node');

  return createAndDownloadExcel(
    rows,
    columns,
    sheetName,
    fileName,
    {
      valueTransformer,
      maxColumnWidth: 50
    }
  );
};
